import { useUserStore } from '@/store/userStore'

export default function ({ redirect }) {
  const userStore = useUserStore()

  if (userStore.loggedIn) {
    return redirect('/')
  }
}
